import { ExternalDestinationType } from "#gen/bundles/v1/bundle_pb.js";

export const SMS_BODY_MAX_LENGTH = 1000;
export const SMS_BODY_WARNING_LENGTH = 160;
export const EMAIL_SUBJECT_MAX_LENGTH = 100;
export const EMAIL_BODY_MAX_LENGTH = 1000;

export const DESTINATION_TYPE_OPTIONS = [
	{ name: "Website", value: ExternalDestinationType.URL, iconName: "link" },
	{ name: "Phone call", value: ExternalDestinationType.PHONE, iconName: "phone" },
	{ name: "Text message", value: ExternalDestinationType.SMS, iconName: "chat-bubble-left-ellipsis" },
	{ name: "Email", value: ExternalDestinationType.EMAIL, iconName: "envelope" },
	{ name: "App deep link", value: ExternalDestinationType.DEEPLINK, iconName: "squares-2x2" },
];

export const COUNTRY_CODES = [
	{ name: "US (+1)", value: "+1", iconName: "us" },
	{ name: "CA (+1)", value: "+1", iconName: "ca" },
	{ name: "MX (+52)", value: "+52", iconName: "mx" },
	{ name: "GB (+44)", value: "+44", iconName: "gb" },
	{ name: "AU (+61)", value: "+61", iconName: "au" },
	{ name: "DE (+49)", value: "+49", iconName: "de" },
	{ name: "FR (+33)", value: "+33", iconName: "fr" },
	{ name: "IT (+39)", value: "+39", iconName: "it" },
	{ name: "ES (+34)", value: "+34", iconName: "es" },
	{ name: "BR (+55)", value: "+55", iconName: "br" },
	{ name: "IN (+91)", value: "+91", iconName: "in" },
	{ name: "CN (+86)", value: "+86", iconName: "cn" },
	{ name: "JP (+81)", value: "+81", iconName: "jp" },
	{ name: "ZA (+27)", value: "+27", iconName: "za" },
	{ name: "RU (+7)", value: "+7", iconName: "ru" },
	{ name: "NZ (+64)", value: "+64", iconName: "nz" },
	{ name: "IE (+353)", value: "+353", iconName: "ie" },
	{ name: "NL (+31)", value: "+31", iconName: "nl" },
	{ name: "SE (+46)", value: "+46", iconName: "se" },
	{ name: "NO (+47)", value: "+47", iconName: "no" },
	{ name: "FI (+358)", value: "+358", iconName: "fi" },
	{ name: "DK (+45)", value: "+45", iconName: "dk" },
	{ name: "BE (+32)", value: "+32", iconName: "be" },
	{ name: "AT (+43)", value: "+43", iconName: "at" },
	{ name: "CH (+41)", value: "+41", iconName: "ch" },
	{ name: "SG (+65)", value: "+65", iconName: "sg" },
	{ name: "MY (+60)", value: "+60", iconName: "my" },
	{ name: "PH (+63)", value: "+63", iconName: "ph" },
	{ name: "TH (+66)", value: "+66", iconName: "th" },
	{ name: "ID (+62)", value: "+62", iconName: "id" },
	{ name: "VN (+84)", value: "+84", iconName: "vn" },
	{ name: "PK (+92)", value: "+92", iconName: "pk" },
	{ name: "BD (+880)", value: "+880", iconName: "bd" },
	{ name: "IL (+972)", value: "+972", iconName: "il" },
	{ name: "SA (+966)", value: "+966", iconName: "sa" },
	{ name: "AE (+971)", value: "+971", iconName: "ae" },
	{ name: "AR (+54)", value: "+54", iconName: "ar" },
	{ name: "CL (+56)", value: "+56", iconName: "cl" },
	{ name: "CO (+57)", value: "+57", iconName: "co" },
	{ name: "PE (+51)", value: "+51", iconName: "pe" },
	{ name: "CU (+53)", value: "+53", iconName: "cu" },
	{ name: "DO (+1-809)", value: "+1-809", iconName: "do" },
	{ name: "CR (+506)", value: "+506", iconName: "cr" },
	{ name: "PA (+507)", value: "+507", iconName: "pa" },
	{ name: "HN (+504)", value: "+504", iconName: "hn" },
	{ name: "EC (+593)", value: "+593", iconName: "ec" },
	{ name: "PY (+595)", value: "+595", iconName: "py" },
	{ name: "UY (+598)", value: "+598", iconName: "uy" },
	{ name: "NP (+977)", value: "+977", iconName: "np" },
	{ name: "LK (+94)", value: "+94", iconName: "lk" },
	{ name: "JO (+962)", value: "+962", iconName: "jo" },
	{ name: "IQ (+964)", value: "+964", iconName: "iq" },
	{ name: "KW (+965)", value: "+965", iconName: "kw" },
	{ name: "OM (+968)", value: "+968", iconName: "om" },
	{ name: "BH (+973)", value: "+973", iconName: "bh" },
	{ name: "QA (+974)", value: "+974", iconName: "qa" },
	{ name: "MN (+976)", value: "+976", iconName: "mn" },
	{ name: "KZ (+7)", value: "+7", iconName: "kz" },
	{ name: "GE (+995)", value: "+995", iconName: "ge" },
	{ name: "AM (+374)", value: "+374", iconName: "am" },
	{ name: "AZ (+994)", value: "+994", iconName: "az" },
	{ name: "DZ (+213)", value: "+213", iconName: "dz" },
	{ name: "EG (+20)", value: "+20", iconName: "eg" },
	{ name: "MA (+212)", value: "+212", iconName: "ma" },
	{ name: "TN (+216)", value: "+216", iconName: "tn" },
	{ name: "NG (+234)", value: "+234", iconName: "ng" },
	{ name: "KE (+254)", value: "+254", iconName: "ke" },
	{ name: "UG (+256)", value: "+256", iconName: "ug" },
	{ name: "GH (+233)", value: "+233", iconName: "gh" },
	{ name: "TZ (+255)", value: "+255", iconName: "tz" },
	{ name: "ZW (+263)", value: "+263", iconName: "zw" },
	{ name: "ZM (+260)", value: "+260", iconName: "zm" },
	{ name: "AO (+244)", value: "+244", iconName: "ao" },
	{ name: "AF (+93)", value: "+93", iconName: "af" },
	{ name: "AL (+355)", value: "+355", iconName: "al" },
	{ name: "AD (+376)", value: "+376", iconName: "ad" },
	{ name: "AW (+297)", value: "+297", iconName: "aw" },
	{ name: "BY (+375)", value: "+375", iconName: "by" },
	{ name: "BZ (+501)", value: "+501", iconName: "bz" },
	{ name: "BO (+591)", value: "+591", iconName: "bo" },
	{ name: "BN (+673)", value: "+673", iconName: "bn" },
	{ name: "BT (+975)", value: "+975", iconName: "bt" },
	{ name: "BW (+267)", value: "+267", iconName: "bw" },
	{ name: "BF (+226)", value: "+226", iconName: "bf" },
	{ name: "BI (+257)", value: "+257", iconName: "bi" },
	{ name: "KH (+855)", value: "+855", iconName: "kh" },
	{ name: "CV (+238)", value: "+238", iconName: "cv" },
	{ name: "CF (+236)", value: "+236", iconName: "cf" },
	{ name: "TD (+235)", value: "+235", iconName: "td" },
	{ name: "KM (+269)", value: "+269", iconName: "km" },
	{ name: "CY (+357)", value: "+357", iconName: "cy" },
	{ name: "DJ (+253)", value: "+253", iconName: "dj" },
	{ name: "TL (+670)", value: "+670", iconName: "tl" },
	{ name: "ER (+291)", value: "+291", iconName: "er" },
	{ name: "ET (+251)", value: "+251", iconName: "et" },
	{ name: "FJ (+679)", value: "+679", iconName: "fj" },
	{ name: "FO (+298)", value: "+298", iconName: "fo" },
	{ name: "GA (+241)", value: "+241", iconName: "ga" },
	{ name: "GM (+220)", value: "+220", iconName: "gm" },
	{ name: "GT (+502)", value: "+502", iconName: "gt" },
	{ name: "GW (+245)", value: "+245", iconName: "gw" },
	{ name: "GY (+592)", value: "+592", iconName: "gy" },
	{ name: "HT (+509)", value: "+509", iconName: "ht" },
	{ name: "IS (+354)", value: "+354", iconName: "is" },
	{ name: "KI (+686)", value: "+686", iconName: "ki" },
	{ name: "LA (+856)", value: "+856", iconName: "la" },
	{ name: "LS (+266)", value: "+266", iconName: "ls" },
	{ name: "LR (+231)", value: "+231", iconName: "lr" },
	{ name: "LI (+423)", value: "+423", iconName: "li" },
	{ name: "LU (+352)", value: "+352", iconName: "lu" },
	{ name: "MG (+261)", value: "+261", iconName: "mg" },
	{ name: "MW (+265)", value: "+265", iconName: "mw" },
	{ name: "MV (+960)", value: "+960", iconName: "mv" },
	{ name: "ML (+223)", value: "+223", iconName: "ml" },
	{ name: "MT (+356)", value: "+356", iconName: "mt" },
	{ name: "MH (+692)", value: "+692", iconName: "mh" },
	{ name: "MR (+222)", value: "+222", iconName: "mr" },
	{ name: "FM (+691)", value: "+691", iconName: "fm" },
	{ name: "MD (+373)", value: "+373", iconName: "md" },
	{ name: "MC (+377)", value: "+377", iconName: "mc" },
	{ name: "ME (+382)", value: "+382", iconName: "me" },
	{ name: "MZ (+258)", value: "+258", iconName: "mz" },
	{ name: "NA (+264)", value: "+264", iconName: "na" },
	{ name: "NR (+674)", value: "+674", iconName: "nr" },
	{ name: "NE (+227)", value: "+227", iconName: "ne" },
	{ name: "NI (+505)", value: "+505", iconName: "ni" },
	{ name: "NU (+683)", value: "+683", iconName: "nu" },
	{ name: "PW (+680)", value: "+680", iconName: "pw" },
	{ name: "PG (+675)", value: "+675", iconName: "pg" },
	{ name: "RE (+262)", value: "+262", iconName: "re" },
	{ name: "RW (+250)", value: "+250", iconName: "rw" },
	{ name: "ST (+239)", value: "+239", iconName: "st" },
	{ name: "WS (+685)", value: "+685", iconName: "ws" },
	{ name: "SM (+378)", value: "+378", iconName: "sm" },
	{ name: "SC (+248)", value: "+248", iconName: "sc" },
	{ name: "SL (+232)", value: "+232", iconName: "sl" },
	{ name: "SB (+677)", value: "+677", iconName: "sb" },
	{ name: "SO (+252)", value: "+252", iconName: "so" },
	{ name: "SR (+597)", value: "+597", iconName: "sr" },
	{ name: "SZ (+268)", value: "+268", iconName: "sz" },
	{ name: "SY (+963)", value: "+963", iconName: "sy" },
	{ name: "TJ (+992)", value: "+992", iconName: "tj" },
	{ name: "TO (+676)", value: "+676", iconName: "to" },
	{ name: "TV (+688)", value: "+688", iconName: "tv" },
	{ name: "UA (+380)", value: "+380", iconName: "ua" },
	{ name: "UZ (+998)", value: "+998", iconName: "uz" },
	{ name: "VU (+678)", value: "+678", iconName: "vu" },
	{ name: "VA (+379)", value: "+379", iconName: "va" },
	{ name: "VE (+58)", value: "+58", iconName: "ve" },
	{ name: "YE (+967)", value: "+967", iconName: "ye" },
];
